import {Component} from "react";
import "../Messaggi/OverPanel.css";
import "./ModerateAction.css";
import SettingsIcon from "../../../media/assets/SettingsIcon.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import Glob from "../../../libs/Glob.mjs";
import {Button, ButtonGroup} from "reactstrap";
import AppNoDislikeIcon from "../../../media/assets/AppNoDislikeIcon.mjs";
import UserIcon from "../../../media/assets/UserIcon.mjs";
import AppDislikeIcon from "../../../media/assets/AppDislikeIcon.mjs";
import CheckIcon from "../../../media/assets/CheckIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import BLib from "../BLib.mjs";

const prefix ="ModerateAction";

const SingleReport = class extends Component {
	render() {
		return(
			<div className={"SingleReport"}>
				<p>
					<strong>{ this.props.name}</strong>
					<em>{this.props.mail}</em>
				</p>
				<div>{ this.props.body }</div>
			</div>
		);
	}
}

const ModerateAction = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
		this.uid = Glob.generateUid(prefix);
		this.close = this.close.bind(this);
		this.moderate = this.moderate.bind(this);
	}
	close() {
		Glob.trigger('ModerateAction');
	}
	moderate() {
		const data = {
			message: this.props.data.id,
			user: this.props.data.userid,
			action: this.state.decision
		};
		this.setState({saving: true}, ()=>{
			appLib.api('admin/moderate-action', data ).then( () => {
				BLib.restartPoll();
				this.close();
			}).catch( err => {
				console.error(err);
			}).finally(() => {
				this.setState({saving: false});
			});
		});
	}
	render() {
		const m = this.props.data;
		return (
			<div
				className={"OverPanel "+prefix+( this.state.saving ? " busy" : "" )}
				id={this.uid}
			>
				<div>
					<h2>
						<SettingsIcon />
						<TextLabel value={"Moderation"} />
						<span className={"closer"} onClick={this.close}>
							<CloseIcon />
						</span>
					</h2>
					<h4>
						«<strong>{ m.subject }</strong>»
					</h4>
					<h6>Autore:</h6>
					<div className={"userdata"}>
						<div>Username: «<strong>{ m.meta.name }</strong>»</div>
						<div>Email: «<strong>{ m.meta.email }</strong>»</div>
					</div>
					{ (!! m.meta.segnalazioni) && (
						<div className={"segnalazioni"}>
							<h6>Segnalazioni: ({m.meta.segnalazioni})</h6>
							{ (m.meta.segnalazioniid||[]).map( (s,i) => (
								<SingleReport
									key={i}
									uid={s}
									name={m.meta.segnalazioniname[i]}
									mail={m.meta.segnalazionimail[i]}
									body={m.meta.segnalazionibody[i]}
								/>
							))}
						</div>
					) }
					<hr />
					<div className={"azioni"}>
						<h6>Azioni di moderazione:</h6>
						<div>
							<ButtonGroup
								className={"btn-icon azioni"}
								vertical={true}
							>
								<Button
									color={ this.state.decision === 'ok' ? "success" : "secondary" }
									onClick={ ()=>{ this.setState({decision: 'ok'}) }}
								>
									<i>
										<AppNoDislikeIcon/>
									</i>
									<b>
										Il post va bene così
									</b>
								</Button>
								<Button
									color={ this.state.decision === 'modpost' ? "warning" : "secondary" }
									onClick={ ()=>{ this.setState({decision: 'modpost'}) }}
								>
									<i>
										<AppDislikeIcon/>
									</i>
									<b>
										Elimina il post
									</b>
								</Button>
								<Button
									color={ this.state.decision === 'moduser' ? "danger" : "secondary" }
									onClick={ ()=>{ this.setState({decision: 'moduser'}) }}
								>
									<i>
										<UserIcon/>
									</i>
									<b>
										Elimina l’utente
									</b>
								</Button>
							</ButtonGroup>
						</div>
						<div>
							{ this.state.decision === 'ok' && (
								<div>
									Il post non sarà toccato, ma eventuali segnalazioni verranno annullate.
								</div>
							)}
							{ this.state.decision === 'modpost' && (
								<div>
									Il post verrà rimosso, eventuali segnalazioni verranno annullate.
								</div>
							)}
							{ this.state.decision === 'moduser' && (
								<div>
									L’utente verrà disabilitato, tutti i suoi post rimossi, eventuali segnalazioni annullate.
								</div>
							)}
							{ ! this.state.decision && (
								<div>
									Qualunque sia la scelta di moderazione, eventuali segnalazioni annullate.
								</div>
							)}
						</div>
						<div>
							<ButtonGroup
								className={"btn-icon"}
							>
								<Button
									color={"warning"}
									onClick={ this.close }
								>
									<i>
										<CloseIcon/>
									</i>
									<b>
										<TextLabel value={"Cancel"} />
									</b>
								</Button>
								<Button
									color={"primary"}
									disabled={ ! this.state.decision }
									onClick={ this.moderate }
								>
									<b>
										<TextLabel value={"Save"} />
									</b>
									<i>
										<CheckIcon />
									</i>
								</Button>
							</ButtonGroup>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ModerateAction;